import { useState } from 'react';
import { SEOHead } from '../components/SEOHead';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FAQ_DATA } from '../data/faqData';
import { translations } from '../translations';

export default function FAQPage({ language, setLanguage }) {
  const t = translations[language];
  const [openIdx, setOpenIdx] = useState(null);
  const [showArabic, setShowArabic] = useState(language === 'ar');

  const toggle = (i) => setOpenIdx(openIdx === i ? null : i);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQ_DATA.map(item => ({
      "@type": "Question",
      "name": item.q,
      "acceptedAnswer": { "@type": "Answer", "text": item.a }
    }))
  };

  return (
    <div className="faq-page" data-testid="faq-page" dir={showArabic ? 'rtl' : 'ltr'}>
      <SEOHead
        title={language === 'ar' ? (t.seo?.faqTitle || 'Frequently Asked Questions Istanbul | Viaturkey') : 'Frequently Asked Questions Istanbul | Viaturkey'}
        description={language === 'ar' ? (t.seo?.faqDesc || '') : "Answers to common questions about private Istanbul tours, Galataport shore excursions, Bosphorus cruises, Turkish citizenship, and real estate investment."}
        canonical="https://viaturkey.net/faq"
        schema={faqSchema}
      />
      <Header language={language} t={t} />

      <section className="sp-hero" data-testid="faq-hero">
        <div className="sp-hero-overlay"></div>
        <div className="sp-hero-content">
          <h1>{showArabic ? 'الأسئلة المتكررة' : 'Frequently Asked Questions'}</h1>
          <p>{showArabic ? 'إجابات على أسئلتكم حول جولات إسطنبول والاستثمار العقاري والجنسية التركية' : 'Answers to your questions about Istanbul tours, real estate investment, and Turkish citizenship'}</p>
        </div>
      </section>

      <div className="sp-container">
        <div className="faq-lang-toggle" data-testid="faq-lang-toggle">
          <button className={!showArabic ? 'active' : ''} onClick={() => setShowArabic(false)} data-testid="faq-lang-en">{showArabic ? 'الإنجليزية' : 'English'}</button>
          <button className={showArabic ? 'active' : ''} onClick={() => setShowArabic(true)} data-testid="faq-lang-ar">العربية</button>
        </div>

        <div className="faq-accordion" data-testid="faq-accordion">
          {FAQ_DATA.map((item, i) => (
            <div key={i} className={`faq-item ${openIdx === i ? 'open' : ''}`} data-testid={`faq-item-${i}`}>
              <button className="faq-question" onClick={() => toggle(i)} data-testid={`faq-q-${i}`}>
                <span>{showArabic ? item.qAr : item.q}</span>
                <i className={`fas fa-chevron-down faq-arrow ${openIdx === i ? 'rotated' : ''}`}></i>
              </button>
              <div className="faq-answer" data-testid={`faq-a-${i}`}>
                <p>{showArabic ? item.aAr : item.a}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="sp-cta" data-testid="faq-cta">
          <h2>{showArabic ? 'لم تجد إجابة لسؤالك؟' : 'Didn\'t find your answer?'}</h2>
          <p>{showArabic ? 'تواصل معنا مباشرة على واتساب — نرد خلال دقائق' : 'Contact us directly on WhatsApp — we respond within minutes'}</p>
          <a href="https://wa.me/905075337545?text=Hi%20Viaturkey!%20I%20have%20a%20question." target="_blank" rel="noopener noreferrer" className="sp-cta-btn" data-testid="faq-whatsapp-btn">
            <i className="fab fa-whatsapp"></i> {showArabic ? 'راسلنا على واتساب' : 'Message Us on WhatsApp'}
          </a>
        </div>
      </div>

      <Footer t={t} />
    </div>
  );
}
